'use client';

import { c as _c } from "react/compiler-runtime";
import { getFormattedCurrency } from '@svenskaspelab/poolbetting/core/lib/client';
import { useDraw } from '@svenskaspelab/poolbetting/core/nextjs/draw';
import type { DrawNumber } from '@svenskaspelab/poolbetting/schema/draw';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import { type ReactNode } from 'react';
import CurrencyCounter from './CurrencyCounter';
type DrawCardNetSaleManagerProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
};

/**
 * Component for draw card net sale.
 *
 * @param root0 Component props
 * @param root0.drawNumber Draw number to load draw from
 * @param root0.product Product number to load draw from
 * @returns component that renders the net sale for a draw
 */
export default function DrawCardNetSaleManager(t0) {
  const $ = _c(10);
  const {
    drawNumber,
    product
  } = t0;
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      drawNumber,
      product
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      select: _temp
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const drawData = useDraw(t1, t2);
  const formattedNetSale = getFormattedCurrency(drawData.data);
  const t3 = `Omsättning: ${formattedNetSale}`;
  const t4 = `net-sale-${drawNumber}-${product}`;
  let t5;
  if ($[4] !== drawData.data || $[5] !== t4) {
    t5 = <CurrencyCounter amount={drawData.data} uniqueId={t4} />;
    $[4] = drawData.data;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div aria-label={t3} aria-live="off">{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(data) {
  return data.draw.currentNetSale;
}